import { OwnerVIPRequestStatus, VIPRequest } from "@eres/vipownerapi/entities";
import React, { Component } from "react";
import ListDataView from "../DataView/ListDataView";
import { LocaleUtil } from "@eres/core";
import { DataTableLang } from "@my-dld/utils/DataTableUtils";
import Strings from "@my-dld/assets/strings";
import { getVIPReqDate, getVIPReqMessage, getVIPReqNo, getVIPReqStatus } from "@my-dld/screens/VIPOwner";

export interface VIPReqProps {
	items: VIPRequest[];
	onCancel: ( item: VIPRequest ) => void;
	onDocuments: ( item: VIPRequest ) => void;
	onManagerDetails: ( item: VIPRequest ) => void;
	onFullMessage: ( item: VIPRequest ) => void;
}

class VIPRequestsListView extends Component<VIPReqProps> {
	componentDidMount(): void {
		this.configDataTable();
	}

	render() {
		const { items } = this.props;
		return <ListDataView
			items={ items }
			renderListHeader={ () => {
				return <RenderHeader/>;
			} }
			renderListItem={ ( item: VIPRequest ) => {
				return <RenderListItem
					key={ getVIPReqNo( item ) }
					item={ item }/>;
			} }/>;
	}

	private configDataTable = () => {
		try {
			window.$( "#ListView" ).DataTable( {
				language: LocaleUtil.Select( DataTableLang ),
				responsive: false,
				lengthChange: false,
				scrollX: true
			} );
			const { onCancel, onDocuments, onManagerDetails, onFullMessage } = this.props;
			window.$( "#ListView" ).on( "click", "a", function () {
				// @ts-ignore
				let item = JSON.parse( this.getAttribute( "data-item" ) );
				if ( item )
					onManagerDetails( item );
				// @ts-ignore
				let item_cancel = JSON.parse( this.getAttribute( "data-item-cancel" ) );
				if ( item_cancel )
					onCancel( item_cancel );
				// @ts-ignore
				let item_documents = JSON.parse( this.getAttribute( "data-item-documents" ) );
				if ( item_documents )
					onDocuments( item_documents );
				return false;
			} );
			window.$( "#ListView" ).on( "click", "button", function () {
				// @ts-ignore
				let item = JSON.parse( this.getAttribute( "data-item" ) );
				if ( item )
					onFullMessage( item );
				return false;
			} );
		} catch ( e ) {
			console.warn( "Data table unavailable", e );
		}
	};
}

function RenderHeader() {
	return <tr>
		<th>{ Strings.request_number }</th>
		<th>{ Strings.status }</th>
		<th>{ Strings.submission_date }</th>
		<th>{ Strings.message }</th>
		<th/>
	</tr>;
}

function RenderListItem( props: { item: VIPRequest } ) {
	const { item } = props;
	const reqNo = getVIPReqNo( item );
	let message = getVIPReqMessage( item );
	const msgLength = message.length;
	message = ( msgLength > 65 ) ? message.substring( 0, 65 ) : message;
	return <tr key={ reqNo }>
		<td data-label={ Strings.request_number }>{ reqNo }</td>
		<td data-label={ Strings.status }>{ getVIPReqStatus( item ) }</td>
		<td data-label={ Strings.submission_date }>{ getVIPReqDate( item ) }</td>
		<td data-label={ Strings.message }>
			<div className="manager-message-wrap">
                <span
	                className="manager-message">{ message }</span>
				{ msgLength > 65 && <button className="btn btn-sm" data-item={ JSON.stringify( item ) }>
					<i className="far fa-eye"/></button> }
			</div>
		</td>
		<td>
			<div className="action-div vip-request-action">
				<a href="#" data-item={ JSON.stringify( item ) }>
					<i className="icon-manager"/>
					<span className="sr-only">{ Strings.manager_details }</span>
				</a>
				{ ( item.Documents && item.Documents.length > 0 ) &&
					<a href="#" data-item-documents={ JSON.stringify( item ) }>
						<i className="icon-document"/><span className="sr-only">{ Strings.documents }</span>
					</a> }
				{ item.RequestStatusId === OwnerVIPRequestStatus.PENDING &&
					<a href="#" data-item-cancel={ JSON.stringify( item ) }>
						<i className="far fa-times-circle"/><span className="sr-only">{ Strings.cancel }</span>
					</a> }
			</div>
		</td>
	</tr>;
}

export default VIPRequestsListView;
